export default class Faq {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        this.onClickQuestionFaq();
    }

    /**
     * FAQ : Toggle effect when you click on a question to show the answer
     */
    onClickQuestionFaq() {
        if (document.getElementsByClassName('assistance-page')[0]) {
            let answers_buttons = document.getElementsByClassName('title');
            let i;

            for (i = 0; i < answers_buttons.length; i++) {
                answers_buttons[i].addEventListener('click', function () {
                    this.classList.toggle('active');
                    let answer = this.nextElementSibling;

                    if (answer.style.maxHeight) {
                        answer.style.maxHeight = null;
                    } else {
                        answer.style.maxHeight = answer.scrollHeight + "px";
                    }
                });
            }
        }
    }
}
